<template>
  <button
    class="c-chat__lastMessagesButton c-button -primary t-button1"
    @click="scrollToLastMessage">
    <SvgIcon
      small
      type="chat_arrow_down" />
    <span>{{$t('chat.last_messages', { count: chatThreadStore?.unSeenMessages })}}</span>
  </button>
</template>

<script setup>
import { watch } from 'vue'

import { useChatStore } from '@/modules/chat/chatStore'
import { useChatThreadStore } from '@/modules/chat/chatThreadStore'

const chatStore = useChatStore()
let chatThreadStore
const scrollToLastMessage = async () => {
  await chatThreadStore.scrollContainerDown()
  await chatStore.updateHasUnreadMessagesInThreads(chatStore.chatThread.azure_chat_thread_id)
}

watch(chatStore, () => {
  if (chatStore.chatThread) {
    chatThreadStore = useChatThreadStore(chatStore.chatThread.azure_chat_thread_id)
  }
}, {
  immediate: true,
})
</script>
